import React, {Fragment} from 'react'
import BigNumber from '../vaccine/bignumbers'
import { formatTimestamp } from '../sfc/component-helpers/datehelpers'
import { dataLabels } from '../vaccine/vaccine-component-helpers/dataLabels'
import summaryNumbersStyles from '../../styles/modules/summarynumbers.module.less'

const sources = {
  CDC: 'Centers for Disease Control and Prevention',
  'TX DHHS': 'Texas Department of Health and Human Services',
  CDPH: 'California Department of Public Health',
}

function getStateDosesAdministered(MARKET_STATE, bigNumbers){
  var doses;
  for(var item in bigNumbers.data){
    var obj = bigNumbers.data[item]
    if(obj.n===MARKET_STATE){
      doses=obj.a
    }
  }
  return doses;
}

function getStateAtLeast(MARKET_STATE, bigNumbers){
  var atleast;
  for(var item in bigNumbers.data){
    var obj = bigNumbers.data[item]
    if(obj.n===MARKET_STATE){
      atleast=obj.num_pv + obj.num_fv
    }
  }
  return atleast;
}

function getUSDosesAdministered(bigNumbers){
  var doses;
  for(var item in bigNumbers.data){
    var obj = bigNumbers.data[item]
    if(obj.n==='United States'){
      doses=obj.a
    }
  }
  return doses;
}

function getUSAtLeast(bigNumbers){
  var atleast;
  for(var item in bigNumbers.data){
    var obj = bigNumbers.data[item]
    if(obj.n==='United States'){
      atleast=obj.num_pv + obj.num_fv
    }
  }
  return atleast;
}




const SummaryNumbers = ({MARKET_STATE, bigNumbers}) => {

  return (
    <div className={summaryNumbersStyles.graphicContainer}>
      {bigNumbers && (
        <Fragment>
          <div className={summaryNumbersStyles.numberContainer}>
            <h5 className={summaryNumbersStyles.numberHeader}>{MARKET_STATE}</h5>
            <div className={summaryNumbersStyles.numberGroup}>
              <BigNumber
                number={getStateDosesAdministered(MARKET_STATE, bigNumbers).toLocaleString()}
                label={dataLabels['administered'].label}
                style="topper partial"
              />
              <BigNumber
                number={getStateAtLeast(MARKET_STATE, bigNumbers).toLocaleString()}
                label={dataLabels['atleast'].label}
                style="topper partial"
              />
            </div>
          </div>

          

          <div className={summaryNumbersStyles.numberContainer}>
            <h5 className={summaryNumbersStyles.numberHeader}>United States</h5>

            <div className={summaryNumbersStyles.numberGroup}>
              <BigNumber
                number={getUSDosesAdministered(bigNumbers).toLocaleString()}
                label={dataLabels['administered'].label}
                style="topper partial"
              />
              <BigNumber
                number={getUSAtLeast(bigNumbers).toLocaleString()}
                label={dataLabels['atleast'].label}
                style="topper partial"
              />
            </div>
          </div>
          
          
          
          <span className={summaryNumbersStyles.numberSource}>
            Source: CDC, updated {formatTimestamp(bigNumbers.mod_date)}

            {/*
            {
              //Assuming USA data will always be CDC, put that if state data isn't
              bigNumbers.state.data.s !== bigNumbers.usa.data.s
                ? `${sources[bigNumbers.state.data.s]} ${
                    sources[bigNumbers.usa.data.s]
                  }`
                : `${sources[bigNumbers.usa.data.s]}`
            }

            */}
          </span>
          
        </Fragment>
      )}
    </div>
  )
}

export default SummaryNumbers